
interface TableExpansionContentArguments extends React.HTMLAttributes<HTMLElement>{
    __TYPE ?: string;
    children ?: any;
}

export function TableExpansionContent(
    props: TableExpansionContentArguments
) {
    return (
        <>
            { props.children }
        </>
    );
}

(TableExpansionContent as any).defaultProps = {
    __TYPE: "__TPM__TableExpansionContent__"
}
